import { FC, useState } from 'react';
import { generateFirstLevelCategoryPageLink } from 'src/utils/links';
import { FirstCategoryLevel } from 'src/api/types';
import NextImage from 'src/shared-components/NextImage/NextImage';
import cn from 'classnames';
import dynamic from 'next/dynamic';
import Skeleton from 'react-loading-skeleton';
import { delayWrapper } from 'src/utils/delayWrapper';
import useGTAG from '../../../../hooks/useGTAG';

const NavigationLink = dynamic(
  () =>
    delayWrapper<typeof NavigationLink>(
      import('src/shared-components/NavigationLink/NavigationLink')
    ),
  {
    loading: () => <Skeleton width={'100%'} height={32} />
  }
);

interface Props {
  category: FirstCategoryLevel;
}

const hoverClass = 'pt-3 text-center fs-caption-bold text-astronautBlue';
const titleStyle = 'flex text-center pt-3 fs-caption-reg text-mako';

const CategoryPlate: FC<Props> = ({ category }) => {
  const [isHoverState, setStateHover] = useState(false);

  const imageUrlSrc = `category/${category?.translitName}.svg`;
  const imageHoverSrc = `category/blue/${category?.translitName}.svg`;
  const imageSrc = isHoverState ? imageHoverSrc : imageUrlSrc;

  const { trackGtagEvent } = useGTAG();

  return (
    <NavigationLink
      href={generateFirstLevelCategoryPageLink({
        category
      })}
      key={category.translitName}
      onClick={() => {
        trackGtagEvent('main_category', category.name, 'category_name');
      }}
    >
      <div
        onMouseEnter={() => setStateHover(true)}
        onMouseLeave={() => setStateHover(false)}
        className="flex w-28 flex-col items-center justify-center"
      >
        <div>
          <NextImage
            alt={category?.translitName}
            src={imageSrc}
            layout="fixed"
            width={80}
            height={80}
            priority
            quality={100}
          />
        </div>
        <p className={cn(isHoverState ? hoverClass : titleStyle)}>
          {' '}
          {category.name}
        </p>
      </div>
    </NavigationLink>
  );
};

export default CategoryPlate;
